import type { AuthenticationKeyFilter } from './types';

export const AUTHENTICATION_PAGE_TEST_ID = 'developers_authentication';
export const AUTHENTICATION_TITLE_TEST_ID =
  'developers_authentication_title-label';
export const AUTHENTICATION_SUBTITLE_TEST_ID =
  'developers_authentication_subtitle-label';

export const AUTHENTICATION_HEADER_TEST_ID = 'developers_authentication_header';
export const AUTHENTICATION_HEADER_CREATE_TEST_ID =
  'developers_authentication_create-btn';

export const AUTHENTICATION_BANNER_TEST_ID = 'developers_authentication_banner';

export const AUTHENTICATION_FILTER_TEST_ID = 'developers_authentication_filter';
export const AUTHENTICATION_FILTER_OPTION_TEST_ID: Record<
  AuthenticationKeyFilter,
  string
> = {
  all: 'developers_authentication_filter_all-radio',
  enabled: 'developers_authentication_filter_enabled-radio',
  disabled: 'developers_authentication_filter_disabled-radio'
};

export const AUTHENTICATION_GRID_TEST_ID = 'developers_authentication_grid';
export const AUTHENTICATION_CARD_TEST_ID = (uuid: string) =>
  `developers_authentication_card-row-${uuid}`;
export const AUTHENTICATION_CARD_COPY_UUID_TEST_ID = (uuid: string) =>
  `developers_authentication_card_uuid-copy-btn-${uuid}`;

export const AUTHENTICATION_EMPTY_TEST_ID = 'developers_authentication_empty';
export const AUTHENTICATION_EMPTY_CTA_TEST_ID =
  'developers_authentication_empty_create-btn';

export const AUTHENTICATION_LOADING_TEST_ID =
  'developers_authentication_content-loading';
export const AUTHENTICATION_ERROR_TEST_ID =
  'developers_authentication_content-error';
export const AUTHENTICATION_FILTERED_EMPTY_TEST_ID =
  'developers_authentication_filtered_empty';
